import { Facebook, Linkedin, Link } from 'lucide-react';
import XIcon from '@/icons/XIcon';
import { LogoInstagramIcon } from '@shopify/polaris-icons';

export enum SocialPlatform {
  Facebook,
  LinkedIn,
  X,
  Instagram,
  CopyLink,
}

export const SOCIAL_PLATFORMS = [
  {
    key: SocialPlatform.Facebook,
    title: 'Facebook',
    Icon: Facebook,
  },
  {
    key: SocialPlatform.LinkedIn,
    title: 'LinkedIn',
    Icon: Linkedin,
  },
  {
    key: SocialPlatform.X,
    title: 'X',
    Icon: XIcon,
  },
  {
    key: SocialPlatform.Instagram,
    title: 'Instagram',
    Icon: LogoInstagramIcon,
  },
  {
    key: SocialPlatform.CopyLink,
    title: 'Copy Link',
    Icon: Link,
  },
] as const;
